import { Action, handleActions } from 'redux-actions';
import { fetchArtAuthorSuccess, FetchArtAuthorSuccessPayload } from './actions';
import { reduxKey } from './constants';
import { ArtBrandedPopupState } from './types';

const defaultState = {
  artAuthor: undefined,
};

const handleFetchPopupArtAuthorSuccess = (
  state,
  { payload }: Action<FetchArtAuthorSuccessPayload>
) => {
  const { user } = payload;
  return {
    ...state,
    artAuthor: user,
  };
};

const reducer = handleActions<ArtBrandedPopupState, any>(
  {
    [fetchArtAuthorSuccess.toString()]: handleFetchPopupArtAuthorSuccess,
  },
  defaultState
);

export default {
  [reduxKey as string]: reducer,
};
